module.exports = __webpack_public_path__ + "media/components/assets/icons/play_blue-5cc7634126d26476069cb7f796af9da1.svg";